module.exports = __webpack_public_path__ + "img/left-carousel.a3412d03.svg";